import script from "./Habilidades.vue?vue&type=script&setup=true&lang=js"
export * from "./Habilidades.vue?vue&type=script&setup=true&lang=js"

import "./Habilidades.css?vue&type=style&index=0&lang=css&external"

const __exports__ = script;

export default __exports__